import { render, staticRenderFns } from "./GameDuration.vue?vue&type=template&id=7fc90af6&scoped=true&"
import script from "./GameDuration.vue?vue&type=script&lang=js&"
export * from "./GameDuration.vue?vue&type=script&lang=js&"
import style0 from "./GameDuration.vue?vue&type=style&index=0&id=7fc90af6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc90af6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc90af6')) {
      api.createRecord('7fc90af6', component.options)
    } else {
      api.reload('7fc90af6', component.options)
    }
    module.hot.accept("./GameDuration.vue?vue&type=template&id=7fc90af6&scoped=true&", function () {
      api.rerender('7fc90af6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/GameDuration.vue"
export default component.exports